import type { IconComponent } from "types/Icon";

export enum CommandPaletteActionType {
  SIMPLE = "simple",
  SUB_LIST_OPENER = "sub-list-opener",
  SUB_LIST_ITEM = "sub-list-item",
}

export type CommandPaletteAction = {
  type: CommandPaletteActionType;
  id: string;
  title: string;
  bucketId: string;
  onAction: () => void;
  keywords?: string[];
  icon?: IconComponent;
  keepModalOpen?: boolean;
  alwaysVisible?: boolean; // Always visible in the search results, skip fuzzy search filtering
  metadata?: {
    title?: string;
    navigationPath?: string;
  };
};

// onAction can't be stored in local storage
export type CommandPaletteRecentAction = Omit<CommandPaletteAction, "onAction"> & {
  usage: {
    count: number;
    lastUsed: number;
    timestamps: number[]; // Last N use timestamps for velocity calculation
  };
};

export type CommandPaletteBucket = {
  id: string;
  title: string;
  order: number;
  keywords?: string[];
  getActions: () => CommandPaletteAction[];
};

export type CommandPaletteBaseEntityItem = {
  id: string;
  name: string;
  spaceDetails: {
    name: string;
  };
};

export type CommandPaletteSearchResult<T extends CommandPaletteBaseEntityItem> = {
  items: T[];
  loading: boolean;
  hasMore: boolean;
  isEmpty: boolean;
};

export type CommandPaletteActiveActionSource = "keyboard" | "mouse";
